import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  useTheme,
} from "@mui/material";
import { SiteAnchorVisual } from "../../../visuals/SiteAnchorVisual";
import { WorldRenderer } from "../../WorldRenderer";
import { CenterFocusStrong, SelectAll } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { WREvents } from "../../WREvents";
import { BaseVisual } from "../../../visuals/BaseVisual";
import { RenderAccordionToolbar } from "../../../components/Minibar";

export function VisualList({
  wr,
  pinned,
  panel,
  togglePin,
}: {
  wr: WorldRenderer;
  pinned: Set<string>;
  panel: string;
  togglePin: (panel: string) => void;
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const [visuals, setVisuals] = useState<BaseVisual[]>([]);
  useEffect(() => {
    const activateSiteListener = () => {
      // Handle site activation logic here if needed
      const activeSite = wr.dataService.activeSite;
      if (activeSite) {
        setVisuals(Array.from(activeSite.visuals.values()));
      }
    };
    wr.onEvent(WREvents.SiteActivated, activateSiteListener);
    const deactivateSiteListener = (site: SiteAnchorVisual) => {
      // Handle site deactivation logic here if needed
      setVisuals([]);
    };
    wr.onEvent(WREvents.SiteDeactivated, deactivateSiteListener);
    wr.onEvent(WREvents.VisualRemoved, activateSiteListener);
    wr.onEvent(WREvents.VisualSaved, activateSiteListener);
    activateSiteListener();
    return () => {
      wr.off(WREvents.SiteActivated, activateSiteListener);
      wr.off(WREvents.SiteDeactivated, deactivateSiteListener);
      wr.off(WREvents.VisualRemoved, activateSiteListener);
      wr.off(WREvents.VisualSaved, activateSiteListener);
    };
  }, [wr]);
  return (
    <>
      <RenderAccordionToolbar
        pinned={pinned}
        panel={panel}
        togglePin={togglePin}
      />
      <List>
        {visuals.map((visual) => (
          <ListItem key={visual._id} disablePadding dense>
            <ListItemButton onClick={() => visual.select()}>
              <ListItemText primary={visual.getFrindlyName()} />
            </ListItemButton>
            <ListItemIcon sx={{ minWidth: "0px" }}>
              <Tooltip title="View" placement="top">
                <IconButton size="small" onClick={() => visual.focusCamera()}>
                  <CenterFocusStrong fontSize="small" />
                </IconButton>
              </Tooltip>
            </ListItemIcon>
          </ListItem>
        ))}
      </List>
    </>
  );
}
